const resetPlaceholderText = () => {
    const label = document.querySelector('.header__search-label');
    const input = document.querySelector('.header__search-input');

    input.addEventListener('focusin', () => {
        !label.classList.contains('header__search-label--active') && label.classList.add('header__search-label--active')
        label.classList.contains('header__search-label--unactive') && label.classList.remove('header__search-label--unactive')
    })

    input.addEventListener('focusout', (e) => {
        if (label.classList.contains('header__search-label--active') && !e.currentTarget.value) {
            label.classList.add('header__search-label--unactive')
            label.classList.remove('header__search-label--active')
        }
    })
}

const showMobileSearch = () => {
    const searchContainer = document.querySelector('.header__right-item--search');
    const searchMobileBtn = document.querySelector('.header__right-item--mobile');

    searchMobileBtn.addEventListener('click', (e) => {
        searchContainer.classList.toggle('header__right-item--search--active');
    })

    searchContainer.addEventListener('click', (e) => {
        if (e.target.classList.contains('header__right-item--search--active')) {
            searchContainer.classList.remove('header__right-item--search--active');
        }
    })
}

const runSearch = () => {
    const search = document.querySelector('.header__search');
    if (search) {
        resetPlaceholderText();
        showMobileSearch();
    }
}

runSearch();